import {
  COMMENT_SUBMIT_SUCCESS,
  ENERGY_EFFICIENCY_ERROR,
  START_FETCHING_ENERGY_EFFICIENCY,
  UPDATE_ENERGY_EFFICIENCY,
} from '../actions/energyEfficiency'
import { EnergyEfficiencyAction } from '../actions/energyEfficiency'
import { EnergyEfficiencyState } from '../types'

export const initialState: EnergyEfficiencyState = {
  loading: false,
  error: '',
}

const energyEfficiencyReducer = (
  state: EnergyEfficiencyState = initialState,
  action: EnergyEfficiencyAction
): EnergyEfficiencyState => {
  switch (action.type) {
    case START_FETCHING_ENERGY_EFFICIENCY:
      return {
        ...state,
        loading: true,
        error: '',
      }

    case UPDATE_ENERGY_EFFICIENCY: {
      return {
        ...state,
        error: '',
        loading: false,
        energyEfficiency: action.payload,
      }
    }

    case ENERGY_EFFICIENCY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case COMMENT_SUBMIT_SUCCESS: {
      if (!state.energyEfficiency) {
        return state
      }

      const { shiftId, legIndex, comment } = action.payload

      const shiftIndex = state.energyEfficiency.shifts.findIndex(
        (shift) => shift.shiftId === shiftId
      )

      if (shiftIndex === -1) {
        return state
      }

      const updatedShifts = [...state.energyEfficiency.shifts]
      const updatedShift = { ...updatedShifts[shiftIndex] }
      const updatedLegs = [...updatedShift.legs]
      const updatedLeg = { ...updatedLegs[legIndex] }

      updatedLeg.comments = [...(updatedLeg.comments || []), comment]

      updatedLegs[legIndex] = updatedLeg
      updatedShift.legs = updatedLegs
      updatedShifts[shiftIndex] = updatedShift

      return {
        ...state,
        energyEfficiency: {
          ...state.energyEfficiency,
          shifts: updatedShifts,
        },
      }
    }

    default:
      return state
  }
}

export default energyEfficiencyReducer
